import Header from "../component/Global/Header";
import Footer from "../component/Global/Footer";
import Home from "../Pages/Home";
import PageNotFound from "../component/Global/404";
import Contact from "../Pages/Home/Menu/Contact-Sales";

import AuthPage from "../component/Auth/index";
import Resources from "../Pages/Home/Menu/Resources";
import Features from "../Pages/Home/Menu/Features";
import Integration from "../Pages/Home/Menu/Integrations";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { useEffect, useState } from "react";
import AboutUs from "../Pages/Home/Menu/About-Us";
import ResetPassword from "../component/Auth/forgotPass";
import Topbar from "../Pages/Dashboard/global/Topbar";
import Sidebar from "../Pages/Dashboard/global/Sidebar";
// import {LogOutPage} from "../Pages/Dashboard/Logout/index"
// auth context
import {
  LoginUIStateConsumer,
  AuthConsumer,
  useAuth,
} from "../context/AuthContext";

// Dashboard Routes
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "../theme";
import UserDashboard from "../Pages/Dashboard/dashboard";
import Team from "../Pages/Dashboard/team";
import Invoices from "../Pages/Dashboard/invoices";
import DashboardContacts from "../Pages/Dashboard/contacts";
import Form from "../Pages/Dashboard/form";
import FAQ from "../Pages/Dashboard/faq";
import Geography from "../Pages/Dashboard/geography";
import Calendar from "../Pages/Dashboard/calendar/calendar";
import Inbox from "../Pages/Dashboard/Mail/inbox";

import Blog from "../Pages/Home/Menu/Resources/Blog";
import TermsAndConditions from "../Pages/Home/Menu/Resources/Terms_and_conditions";
import Faqs from "../Pages/Home/Menu/Resources/Faqs";
import { Profile } from "../Pages/Dashboard/Profile/index";
import Automations from "../Pages/Home/Menu/Automation/automations";
import Task from "../Pages/Dashboard/Task/task";
import TaskDetail from "../Pages/Dashboard/Task/task_details";
//load dashboard component data

//

const RouterComponent = () => {
  const [currentUrl, setCurrentUrl] = useState(window.location.pathname);
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);

  const { currentUser, currentUserID } = useAuth();
  const localCurrentUser = localStorage.getItem("authUser");

  var authString = "/auth";

  return (
    <AuthConsumer>
      {(authUser) => {
        return (
          <>
            {localCurrentUser ? (
              <>
                <ColorModeContext.Provider value={colorMode}>
                  <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <div className="app">
                      <Sidebar isSidebar={isSidebar} />
                      <main className="content">
                        <Topbar setIsSidebar={setIsSidebar} />
                        <Routes>
                          <Route path="/" element={<UserDashboard />} />
                          <Route path="/team" element={<Team />} />
                          <Route
                            path="/contacts"
                            element={<DashboardContacts />}
                          />
                          <Route path="/invoices" element={<Invoices />} />
                          <Route path="/form" element={<Form />} />

                          <Route path="/faq" element={<FAQ />} />
                          <Route path="/task" element={<Task />} />
                          <Route
                            path="/task/task-details"
                            element={<TaskDetail />}
                          />
                          <Route path="/calendar" element={<Calendar />} />
                          <Route path="/profile" element={<Profile />} />

                          <Route path="/geography" element={<Geography />} />
                          <Route path="/mail/inbox" element={<Inbox />} />
                        </Routes>
                      </main>
                    </div>
                  </ThemeProvider>
                </ColorModeContext.Provider>
              </>
            ) : (
              <>
                {currentUrl.includes(authString) ? <></> : <Header />}
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/auth" element={<AuthPage />} />
                  <Route
                    path="auth/password-reset"
                    element={<ResetPassword />}
                  />
                  <Route path="/contact-sales" element={<Contact />} />
                  <Route path="/about-us" element={<AboutUs />} />
                  <Route path="/features" element={<Features />} />
                  <Route
                    path="/features/integrations"
                    element={<Integration />}
                  />
                  <Route path="/resources" element={<Resources />} />
                  <Route path="/resources/blog" element={<Blog />} />
                  <Route
                    path="/resources/terms-and-conditions"
                    element={<TermsAndConditions />}
                  />
                  <Route path="/resources/faqs" element={<Faqs />} />

                  {/* <Route
                    path="/resource/testimonials"
                    element={<Resources />}
                  /> */}
                  <Route path="/automations" element={<Automations />} />
                  <Route path="/integrations" element={<Integration />} />
                  <Route path="*" element={<PageNotFound />} />
                </Routes>
                {currentUrl.includes(authString) ? <></> : <Footer />}
              </>
            )}
          </>
        );
      }}
    </AuthConsumer>
  );
};

export default RouterComponent;
